import React from "react";
import html5 from "../assets/images/html5.svg";
import css3 from "../assets/images/css3.svg";
import javascript from "../assets/images/javascript.svg";
import sass from "../assets/images/sass.svg";
import reactImg from "../assets/images/react.svg";
import reduxImg from "../assets/images/redux.svg";
import git from "../assets/images/git.svg";
import express from "../assets/images/express.svg";
import mongodb from "../assets/images/mongodb.svg";
import nodejs from "../assets/images/nodejs.svg";
import nextImg from "../assets/images/next.svg";
import loopbackImg from "../assets/images/loopback.svg";
import flutter from "../assets/images/flutter.svg";
import dart from "../assets/images/dart.svg";
// import wpgraphql from "../assets/images/wpgraphql.svg";
const technologies = [
  { label: "React native", src: reactImg },
  { label: "Flutter", src: flutter },
  { label: "Dart", src: dart },
  { label: "Javascript", src: javascript },
  { label: "ReactJs", src: reactImg },
  { label: "NextJs", src: nextImg },
  { label: "Git", src: git },
  { label: "NodeJs", src: nodejs },
  { label: "ExpressJs", src: express },
  { label: "MongoDB", src: mongodb },
  { label: "LoopBack", src: loopbackImg },
  { label: "Html", src: html5 },
  { label: "Css", src: css3 },
  { label: "Sass", src: sass },
  { label: "Redux", src: reduxImg },
];
const Skill = () => {
  return (
    <section className="skill" id="skills">
      <h1 className="heading-1">Skills</h1>
      <div className="skill-wrapper">
        {technologies.map((tech) => (
          <figure className="skill-wrapper__fig">
            <img
              src={tech?.src}
              className="skill-wrapper__img"
              alt={tech.label}
            />
            <figcaption className="skill-wrapper__caption">
              <pre>{tech?.label}</pre>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};

export default Skill;
